import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import { getAuth, patchAuth, postAuth, deleteAuth } from 'api/Utils';



export function getViewPromptOverview(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/extensions/prompt-overview`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


export function getViewPromptConnections(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/extensions/prompt-connections`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewManagePrompts(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/extensions/manage-prompts`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


function pathViewPromptEditor(promptId=null) {
  if (promptId) {
      return `view/extensions/prompt-editor/${promptId}`;
  } else {
      return `view/extensions/prompt-editor`;
  }
}

export function getViewPromptEditor(successCallback, errorCallback, promptId, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewPromptEditor(promptId), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathPrompts(promptId=null) {
  if (promptId) {
      return `extensions/prompts/${promptId}`;
  } else {
      return `extensions/prompts`;
  }
}

export function createPrompts(successCallback, errorCallback, data) {
  postAuth({
    "path": pathPrompts(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchPrompts(successCallback, errorCallback, data, promptId) {
  patchAuth({
    "path": pathPrompts(promptId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deletePrompts(successCallback, errorCallback, promptId) {
  deleteAuth({
    "path": pathPrompts(promptId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

// Preview
export function getViewPromptPreview(successCallback, errorCallback, promptId, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/extensions/prompt-preview/${promptId}`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}



// Analytics
export function getViewPromptAnalytics(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/extensions/prompt-analytics`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


// Sales
export function getViewManagePromptSales(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/extensions/manage-prompt-sales`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


// Response
function pathPromptResponses(responseId=null) {
  if (responseId) {
      return `extensions/prompt-responses/${responseId}`;
  } else {
      return `extensions/prompt-responses`;
  }
}

export function deletePromptResponses(successCallback, errorCallback, responseId) {
  deleteAuth({
    "path": pathPromptResponses(responseId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewManagePromptResponses(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/extensions/manage-prompt-responses`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


// Sync
export function getViewManagePromptSyncLogs(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/extensions/manage-prompt-sync-logs`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}



export const URL_PROMPT_IMAGE_MEDIA = `/${constants.API_VERSION}/extensions/prompts/image-media`;
